import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const colors = {
  chart: {
    exact: "#04aade",       // Updated color for Exact Matches
    conceptual: "#78d0ef"   // Updated color for Conceptual Matches
  },
  text: {
    dark: '#04aade',        
    medium: '#04aade'       
  },
  accent: '#ede9fe'         // Very light background accent
};

// Custom tooltip component.
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const exact = payload.find(p => p.dataKey === 'exact')?.value || 0;
    const conceptual = payload.find(p => p.dataKey === 'conceptual')?.value || 0;
    return (
      <div
        style={{
          backgroundColor: "white",
          padding: "0.75rem",
          border: "1px solid #e5e7eb",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          borderRadius: "4px",
        }}
      >
        <p style={{ margin: 0, fontWeight: 500, color: "#374151" }}>{label}</p>
        <p style={{ margin: 0, fontSize: "0.875rem", color: "#4B5563" }}>
          {`Exact: ${exact}`}
        </p>
        <p style={{ margin: 0, fontSize: "0.875rem", color: "#4B5563" }}>
          {`Conceptual: ${conceptual}`}
        </p>
        <p
          style={{
            margin: 0,
            fontSize: "0.875rem",
            fontWeight: 500,
            marginTop: "0.5rem",
            paddingTop: "0.5rem",
            borderTop: "1px solid #e5e7eb",
            color: "#4B5563",
          }}
        >
          {`Total: ${exact + conceptual}`}
        </p>
      </div>
    );
  }
  return null;
};

// Formatter to round numbers to 4 decimal places.
const formatTick = (value) => {
  return typeof value === "number" ? Number(value.toFixed(4)) : value;
};

const formatXAxisTick = (value) => {
  if (value && value.length > 10) {
    return `${value.substring(0, 10)}...`;
  }
  return value;
};

const SmallMultipleChart = ({ location, data, showExact, showConceptual, minYAxis, maxYAxis }) => {
  return (
    <div
      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
      style={{
        maxWidth: 356,
        width: "100%",
        border: "1px solid #e5e7eb",
        padding: "16px",
        borderRadius: "8px"
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h3
          style={{
            color: colors.text.dark,
            borderBottom: `1px solid ${colors.accent}`,
            paddingBottom: "0.5rem",
            margin: "0 auto",
            width: "100%"
          }}
        >
          {location}
        </h3>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.2} stroke={colors.accent} />
          <XAxis
            dataKey="concept"
            tick={{ fontSize: 10, fill: colors.text.medium }}
            tickFormatter={formatXAxisTick}
            angle={-45}
            textAnchor="end"
            height={50}
            axisLine={{ stroke: colors.accent }}
            interval={0}
          />
          <YAxis
            tick={{ fontSize: 10, fill: colors.text.medium }}
            tickLine={false}
            axisLine={false}
            domain={[minYAxis, maxYAxis]}
            tickFormatter={formatTick}
          />
          <Tooltip content={<CustomTooltip />} />
          {showExact && (
            <Bar
              dataKey="exact"
              stackId="a"
              fill={colors.chart.exact}
              name="Exact Matches"
              radius={[4, 4, 0, 0]}
            />
          )}
          {showConceptual && (
            <Bar
              dataKey="conceptual"
              stackId="a"
              fill={colors.chart.conceptual}
              name="Conceptual Matches"
              radius={[4, 4, 0, 0]}
            />
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SmallMultipleChart;
